<template>
  <div class="login-warp">
    <button @click="$refs.login.show()" class="login-btn" v-if="isLogin">
      登录
    </button>
    <div v-else :style="{color: isEvent ? '#999':'white'}">
      <span v-if="userInfo" @click="center">
        <img :src="userInfo.headSrc || defaultAvatar" class="user-img" />
        <span class="login-name">{{ userInfo.nickname || "我的账号" }}</span>
      </span>
      <a-divider type="vertical" />
      <span @click="loginOut" class="login-out">退出登录</span>
    </div>
    <div style="position: absolute;top: 6px;right: -150px;" v-if="isDaoba" >
      <span @click="changeLang('zh')" :style="{color: lang && lang === 'zh' ? '#a80000' : '#BBBBBB'}">简体</span> /
      <span @click="changeLang('tw')" :style="{color: lang && lang === 'tw' ? '#a80000' : '#BBBBBB'}">繁体</span> /
      <span @click="changeLang('en')" :style="{color: lang && lang === 'en' ? '#a80000' : '#BBBBBB'}">English</span>
    </div>
    <div>
        <Login ref="login" />
    </div>
    <BindPhone ref="bindPhone"/>
  </div>
</template>

<script>
import store from '@/store'
import Login from './Login.vue'
import BindPhone from './BindPhone.vue'
import { createNamespacedHelpers, mapState } from 'vuex'
const { mapActions } = createNamespacedHelpers('user')
export default {
  components: {
    Login,
    BindPhone
  },
  props: {
    isEvent: {
      type: Boolean,
      default: false
    },
    isDaoba:{
      type: Boolean,
      default: true
      
    }
  },
  name: 'MatchInfo',
  created () {
    this.isLogin = store.getters['user/accessToken'] === ''
    this.code = this.$route.query.code || ''
    if (this.code) {
      const {
        Login
      } = this
      let valData = {
        grant_type: 'wechat',
        client_secret: '123456',
        client_id: 'app',
        wechat_type: 'open_platform',
        code: this.code
      }
      Login(valData)
        .then((res) => this.loginSuccess(res))
        .catch(err => this.requestFailed(err))
        .finally(() => {
        })
    }
  },
  mounted () {
    if (!this.isLogin && store.getters['user/isBind'] === 0) {
      this.$refs.bindPhone.show()
    }
  },
  data () {
    return {
      isLogin: true,
      defaultAvatar: require('@comm/assets/userdef.png'),
      code: '',
      lang: localStorage.getItem('lang')
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      isBind: state => state.user.isBind,
      activeMenu: state => state.match.activeMenu
    }),
    activeMenu: {
      get () {
        return store.getters['match/activeMenu']
      },
      set (val) {
        console.log(val)
      }
    }
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    loginSuccess (res) {
      // 如果登录成功
      if (res.status === 0) {
        // 没有绑定手机号码
        if (this.isBind === 0) {
          this.$refs.bindPhone.show()
        } else {
          this.isLogin = false
          this.$notification['success']({
            message: '登录成功',
            description: '',
            duration: 4
          })
          this.$router.push({path: store.getters['user/loginUrl']})
        }
      }
    },
    loginOut () {
      store.commit('join/JOIN_CHANGE_AGENCY_INFO', {
        agencyId: null,
        agencyLogo: null,
        abbreviation: null
      })
      const {
        Logout
      } = this
      Logout()
        .then(res => { window.location.href = '/' })
        .catch()
        .finally(() => {})
    },
    requestFailed (err) {
      this.$notification['error']({
        message: '错误',
        description: err,
        duration: 4
      })
    },
    center () {
      this.$router.push({path: '/Center'})
    },
    changeLang (type) {
      localStorage.setItem('lang', type)
      this.lang = type
      this.$i18n.locale = type // 用于切换语言监听，实时刷新语言
    }
  }
}
</script>

<style lang="scss" scoped>
.login-warp{
    cursor: pointer;
    // top: -7px;
    position: absolute;
    width: 240px;
    right: 0;
    text-align: right;
}
.user-img {
 width:36px;
 height:36px;
 border-radius:50%
}
.login-btn {
  width: 80px;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
//   color: #a80000;
  background: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 3px 15px;
  outline: none;
  margin-top: 4px;
  color: rgba(0,0,0,.65);
}

.login-name{
    display: inline-block;
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: -5px;
}
.login-btn:hover {
//   background: #ffd5d5;
  color: #a80000;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/LoginTag.vue